export default '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342"><path fill="#FFDA44" d="M0 0h512v342H0z"/><path fill="#6DA544" d="M342 0h171v342H342z"/><path fill="#D80027" d="M0 0h171v342H0z"/></svg>'
